/**
 * @function to Zipcode lookup Fetch Method
 * @param var countryCode and Retails sessionID
 * @returns  api url & payload 
 */

const zipCodeLookUpApiPayload = (countryCode, host, retailSessionID, zipCode) => {
    const zipCodeApiEndpoint = `https://${host}/retailpresentationservice/rest/api/v1.0/GetCityStatesByPostalCode`;
    try {
        const reqPayload = {
            "iso_address": {
                "country_iso_code": (countryCode) ? countryCode.toUpperCase() : 'US',
                "postal_code": zipCode
            },
            "security": {
                "session": {
                    "id": retailSessionID
                },
                "client_ip": "115114136244",
                "requestHeader": []
            }
        };

        return {
            zipCodeApiEndpoint,
            reqPayload
        }

    } catch (e) {
        console.warn('Error in zipcode api service', e)
    }

}

const ZipCodeApiLookUpMethod = (countryCode, host, retailSessionID, zipCode) => {
    const { zipCodeApiEndpoint, reqPayload } = zipCodeLookUpApiPayload(countryCode, host, retailSessionID, zipCode);
    return httpRequest.post(zipCodeApiEndpoint, reqPayload, { "Content-type": "application/json" });
}